// MessageInput.js
import React, { useState } from 'react';
import './MessageInput.css';

const MessageInput = ({ onSend }) => {
  const [message, setMessage] = useState('');

  const handleChange = (e) => {
    setMessage(e.target.value);
  };

  const handleSend = () => {
    if (message.trim() !== '') {
      onSend(message,'user'); // Call the onSend function passed from ChatPage
      setMessage('');
    }
  };

  return (
    <div className="message-input">
      <input className="borderCurved"
        type="text"
        placeholder="Type your message..."
        value={message}
        onChange={handleChange}
      />
      <button className="send-button" onClick={handleSend}>
        Send
      </button>
    </div>
  );
};

export default MessageInput;